<div class="popup-overlay" *ngIf="isVisible">
  <div
    class="popup-container"
    (click)="$event.stopPropagation()"
    [ngClass]="{ 'image-popup': isImagePopup }"
  >
    <div class="popup-header" *ngIf="showHeader">
      <div class="popup-header-left">
        <h3 class="popup-title">{{ title }}</h3>
        <div class="popup-subtitle" *ngIf="subTitle || subTitleSuffix">
          <span *ngIf="subTitle" [innerHTML]="subTitle"></span>
          <span *ngIf="subTitleSuffix"> - <span class="popup-subtitle-suffix">{{ subTitleSuffix }}</span></span>
        </div>
      </div>
      <sra-icon-button size="sm">
        <sra-svg-icons
          name="close"
          title="{{ 'PAGE.TITLES.CLOSE' | translate }}"
          className="icon-attachment icon-size-12"
          ariaHidden="false"
          focusable="false"
          (click)="closePopup()"/>
      </sra-icon-button>
    </div>
    <span *ngIf="isImagePopup" class="image-close-btn">
      <sra-icon-button size="xs" (buttonClick)="closePopup()">
        <sra-svg-icons
          name="close"
          title="{{ 'PAGE.TITLES.CLOSE' | translate }}"
          className="icon-white icon-size-10"
          ariaHidden="false"
          focusable="false"/>
      </sra-icon-button>
    </span>
    <!-- download button shown for image popups when enabled -->
    <span *ngIf="isImagePopup && showDownload" class="image-download-btn">
      <sra-icon-button size="xs" (buttonClick)="onDownloadClick()">
        <sra-svg-icons
          name="download"
          title="{{ 'PAGE.TITLES.DOWNLOAD' | translate }}"
          className="icon-white icon-size-12"
          ariaHidden="false"
          focusable="false"/>
      </sra-icon-button>
    </span>
    <div class="popup-body">
      <ng-content></ng-content>
    </div>
    <div class="popup-footer" *ngIf="showFooter && !showOk">
      <sra-button
        id="cancel"
        hierarchy="secondary"
        (click)="closePopup()"
        ariaLabel="Cancel"
        label="Cancel"
        size="sm"
      ></sra-button>
      <sra-button
        id="clear"
        hierarchy="primary"
        (click)="emitValue()"
        ariaLabel="Clear"
        [label]="value"
        size="sm"
        [disabled]="false"
      ></sra-button>
    </div>

    <div class="popup-footer" *ngIf="showFooter && showOk">
      <sra-button
        id="cancel"
        hierarchy="primary"
        (click)="emitValue();closePopup()"
        ariaLabel="cancel"
        [label]="'PAGE.LABELS.OK' | translate"
        size="sm"
        [disabled]="false"
      ></sra-button>
    </div>
  </div>
</div>
